import React from "react";
import { Link } from "react-router-dom";

function Footer() {
  return (
    <>
      <div className="bg-dark text-light">
        {/* <div className="row m-0 bg-danger d-flex justify-content-center align-items-center text-center pt-5 pb-5">
          <div>
            <p className="pb-3" style={{ fontFamily: "Lobster Two, cursive", fontSize: "3rem" }}>
              Beba con{" "}
              <span style={{ color: "rgb(119, 33, 33)", fontWeight: "bolder" }}>moderación </span>,
              <br />
              es <span style={{ color: "rgb(119, 33, 33)", fontWeight: "bolder" }}>su </span>
              responsabilidad.
            </p>
            <p className="pb-5" style={{ fontFamily: "Lobster Two, cursive", fontSize: "1.5rem" }}>
              Si no lo hace por su bienestar, hágalo por el de aquellos que aún lo esperan en casa.
            </p>
          </div>

          <div>
            El consumo excesivo de alcohol tiene efectos inmediatos que aumentan el riesgo de muchas
            consecuencias dañinas para la salud, incluyendo las siguientes:
            <p>
              - Lesiones, como por choques de vehículos automotores, caídas, ahogamientos y
              quemaduras.
            </p>
            <p>
              - Violencia, como homicidios, suicidios, agresión sexual y violencia doméstica con
              parejas sexuales.
            </p>
            <p className="pb-3">
              - Abortos espontáneos y muerte fetal o trastornos del espectro alcohólico fetal en las
              mujeres embarazadas y los bebés
            </p>
          </div>
        </div> */}
        <div className="container">
          <div className="row">
            <div className="col-lg-8 mt-5">
              <div className="row">
                <div className="col-lg-4">
                  <p className="fs-5 pb-3">
                    <i className="fas fa-inbox"></i> Contacto
                  </p>
                  <p className="pb-3 fs-6">hola@twc.uy</p>
                  <p className="pb-3 fs-6">T: 099 111 222</p>
                  <p className="pb-5 fs-6">
                    <span>
                      <i
                        className="fab fa-instagram fs-3 pe-3"
                        type="button"
                        onClick={() =>
                          window.open(
                            "https://www.youtube.com/watch?v=DLzxrzFCyOs&ab_channel=AllKindsOfStuff",
                            "_blank",
                          )
                        }
                      ></i>
                    </span>
                    <span>
                      <i
                        className="fab fa-spotify fs-3"
                        type="button"
                        onClick={() =>
                          window.open(
                            "https://www.youtube.com/watch?v=DLzxrzFCyOs&ab_channel=AllKindsOfStuff",
                            "_blank",
                          )
                        }
                      ></i>
                    </span>
                  </p>
                  <p
                    className="pb-3 fs-6"
                    type="button"
                    onClick={() =>
                      window.open(
                        "https://www.youtube.com/watch?v=BwSts2s4ba4&ab_channel=AdeliciousGeneve",
                        "_blank",
                      )
                    }
                  >
                    Politica de privacidad
                  </p>
                </div>
                <div className="col-lg-4">
                  <p className="fs-5 pb-3">
                    <i className="fas fa-store"></i> Locales
                  </p>
                  <p className="fs-6">
                    <i className="far fa-dot-circle"></i> TWC - Punta Carretas
                  </p>
                  <p className="fs-6">Calle Falsa 1234</p>
                  <p className="pb-5 fs-6">Horario: 9:00–20:00hs</p>
                  <p className="fs-6">
                    <i className="far fa-dot-circle"></i> TWC - Centro
                  </p>
                  <p className="fs-6">18 de Julio 4321</p>
                  <p className="pb-3 fs-6">Horario: 9:00–18:00hs</p>
                </div>
                <div className="col-lg-4">
                  <p className="fs-5 pb-3">
                    <i className="fas fa-shopping-basket"></i> Tienda
                  </p>
                  <Link
                    to="/productos"
                    className="fs-6 pb-3"
                    type="button"
                    style={{ color: "#fff" }}
                  >
                    PRODUCTOS
                  </Link>
                  <Link to="/faqs" className="fs-6 pb-3" type="button" style={{ color: "#fff" }}>
                    PREGUNTAS FRECUENTES
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-lg-4 mt-5 ">
              <p className="fs-5">
                <i className="far fa-envelope"></i> Recibi nuestras recomendaciones
              </p>
              <div className="row mt-3 d-flex align-items-center">
                <div className="col-6">
                  <input type="email" className="form-control" placeholder="@"></input>
                </div>
                <div className="col-6">
                  <button type="button" className="btn btn-secondary">
                    Enviar <i className="fas fa-paper-plane"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="row  mt-5">
            <div className="text-center p-4">
              <div className="fs-5 d-flex flex-column align-items-center navbar-brand">
                <span className="logo_diferent  fs-5 text-light pb-1">The </span>
                <span className="logo  fs-5  pb-1">Wine </span>
                <span className="logo_diferent  fs-5 text-light pb-1">Cabinet</span>
              </div>
            </div>
          </div>
        </div>
        <hr className="mt-2" />
        <div className="container ">
          <div className="row ">
            <div className="d-flex justify-content-between align-items-center mt-1 mb-3">
              <span>© 2021 HackAcademy</span>
              <span>
                <img
                  src="https://media-exp1.licdn.com/dms/image/C4D0BAQHt10pSZLeEMg/company-logo_200_200/0/1519922049619?e=2159024400&v=beta&t=-UoG2Q-PtevrwVwcODGz6H4UedweinsVkBzw13VewhI"
                  alt="HA Logo"
                  style={{ height: "30px" }}
                  type="button"
                  onClick={() => window.open("https://ha.dev/", "_blank")}
                ></img>
              </span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Footer;
